import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getSessionRegistrantDetails } from '../../Apis/ReportingReadApi';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';
import {
  GET_SESSION_ATTENDEES_FAILURE,
  GET_SESSION_ATTENDEES_REQUEST,
  GET_SESSION_ATTENDEES_SUCCESS
} from './SessionAttendeesActions';

export function* getSessionAttendeesWatcher() {
  yield takeLatest(GET_SESSION_ATTENDEES_REQUEST, getSessionAttendeesWorker);
}

export function* getSessionAttendeesWorker({ payload }) {
  const { sessionKey, pageNumber, filter, sort } = payload;
  try {
    const axiosResponse = yield call(getSessionRegistrantDetails, sessionKey, pageNumber, filter, sort, true);
    let attendees = axiosResponse.data._embedded ? axiosResponse.data._embedded.registrants : [];
    let page = axiosResponse.data.page;
    yield put({
      type: GET_SESSION_ATTENDEES_SUCCESS,
      payload: { attendees, page, filter, sort }
    });
  } catch (error) {
    yield put({ type: GET_SESSION_ATTENDEES_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getSessionAttendeesWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionAttendees/SessionAttendeesSagas.js